import React from 'react';
import './styleDev.css'

const IconLeftMenuDevice: React.FC = () => (
    /*<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0 0H9V6.5H0L0 0ZM2 2V4.5H7V2H2ZM0 9H9V20H0L0 9ZM2 11V18H7V11H2ZM20 0H11V9H20V0ZM13 7V2H18V7H13ZM19 12H12V19H19V12Z"
              fill="#575655"/>
    </svg>*/
    <svg className="svg" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M0.666016 1.33317C0.666016 0.964981 0.964492 0.666504 1.33268 0.666504H10.666C11.0342 0.666504 11.3327 0.964981 11.3327 1.33317V14.6665C11.3327 15.0347 11.0342 15.3332 10.666 15.3332H1.33268C0.964492 15.3332 0.666016 15.0347 0.666016 14.6665V1.33317ZM8.66602 3.33317V11.9998H3.33268V3.33317H8.66602ZM1.99935 1.99984V13.9998H9.99935V1.99984H1.99935ZM7.99935 13.3332V12.6665H3.99935V13.3332H7.99935Z"
            fill="#3E405F" />
    </svg>

);

export default IconLeftMenuDevice;